import { render, staticRenderFns } from "./LogoFull.vue?vue&type=template&id=d937e4e8&scoped=true&"
import script from "./LogoFull.vue?vue&type=script&lang=js&"
export * from "./LogoFull.vue?vue&type=script&lang=js&"
import style0 from "./LogoFull.vue?vue&type=style&index=0&id=d937e4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d937e4e8",
  null
  
)

export default component.exports